<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'

const model = defineModel<boolean>()

function close (): void {
  model.value = false
}
</script>

<template>
  <CustomModalWindow v-model="model" :click-to-close="false" disable-close-icon>
    <template #title>
      Спасибо!
    </template>

    <p>Ваша заявка принята. Мы рассмотрим её в&nbsp;ближайшее время.</p>

    <!--<p>Ваша заявка принята. Чтобы мы&nbsp;рассмотрели&nbsp;её, заполните информацию о&nbsp;товарах.</p>-->

    <template #action>
      <BasicButton class="mt-2" color="body-background" title="Закрыть" @click="close" />
    </template>
  </CustomModalWindow>
</template>
